<template>
  <v-layout row>
    <v-flex grow>
      <table style="width: 100%;">
        <thead>
          <tr>
            <th class="text-xs-left">Type</th>
            <th class="text-xs-left">Date</th>
            <th class="text-xs-left">Time</th>
          </tr>
        </thead>
        <tbody>
          <PunchRow
            :punch="punch"
            v-for="punch in sortedPunches"
            :key="punch.id"
          >
          </PunchRow>
        </tbody>
      </table>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

import PunchRow from '@/components/calendar/punch.vue'

export default {
  props: [
    'shift',
    'user',
  ],

  components: {
    PunchRow,
  },

  data() {
    return {
      decisionApiCallPending: false,
    }
  },

  computed: {
    ...mapGetters('timeclock', [
      'sortedPunches',
    ]),
  },

  methods: {
    approveChanges () {
      this.decisionApiCallPending = true
      this.$store.dispatch('shifts/approveChanges', this.shift.id)
      .then(r => {
      })
      .finally(r => {
        this.decisionApiCallPending = false
      })
    },
    denyChanges () {
      this.decisionApiCallPending = true
      this.$store.dispatch('shifts/denyChanges', this.shift.id)
      .then(r => {
      })
      .finally(r => {
        this.decisionApiCallPending = false
      })
    },
  },

}
</script>
